import React from 'react'
import { classNames } from '@/shared/lib/utils/classNames'
import bgstars from '@/shared/assets/desktop/bgstars.webp'

import cls from './BGStars.module.scss'

export const BGStars = ({ className }) => {
    return (
        <div className={classNames(cls.bgstars, [className])}>
            <div className={cls.topshadow} />
            <img
                src={bgstars}
                alt=""
            />
            <div className={cls.shadow} />
        </div>
    )
}
